import React from "react";

import BaseComponent from "../../baseComponent.js";
import InternalEventBus from "../../../core/utils/internalEventBus";
import InternalEvent from "../../../core/constants/internalEvent";
import WidgetService from "../../../core/services/widgetService";

import Widget from "../../../core/models/widget.js";
import {InputControl} from "./inputControl.jsx";
import {SelectionControl} from "./selectionControl.jsx";
import {DatasetControl} from "./datasetControl.jsx";
import styles from './styles.scss';
import {variableTypes} from "./selection-contorl/constants.js";

const updateDelay = 500;

export class ControlWidget extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.widget.metaData.value,
      timezone: this.props.widget.metaData.type === "input" ? this.props.widget.metaData.variable.timezone : "",
      selected: this.getInitialSelection(),
      showLabel: true,
      scale: 1
    };

    this.subscribe(InternalEvent.App.DOCUMENT_CLICKED, (e) => {
      // $(this.refs.container).parents("li").css("z-index", 2);
    });
  }

  getInitialSelection() {
    const metaData = this.props.widget.metaData;
    let selected = null;
    if (metaData.type === "selection") {
      selected = this.props.widget.metaData.selections.find(s => s.id === metaData.currentSelectionId);
    }
    return selected;
  }

  componentDidMount() {
    Materialize.updateTextFields();
    this.toggleLabel();
    InternalEventBus.subscribe(InternalEvent.Dashboard.STANDALONE_DASHBOARD_RESIZED, this.toggleLabel);
  }

  componentDidUpdate() {
    $(this.refs.container).find("select").material_select();
  }

  componentWillUnmount() {
    this.unsubscribeAll();
  }

  toggleLabel() {
    const container = $(this.refs.container);
    const parentHeight = container.parents("li").height();
    let scale = parentHeight / 40;
    if (scale < 0.5) {
      scale = 0.5;
    } else if (scale > 1) {
      scale = 1;
    }
    if (parentHeight < 50) {
      this.setState({showLabel: false, scale});
    } else {
      this.setState({showLabel: true, scale});
    }
  }

  publishControlVariableChangeEvent(type, newData) {
    const metaDataCopy = JSON.parse(JSON.stringify(this.props.widget.metaData));
    if (type === "input") {
      metaDataCopy.value = newData[0].value;
      metaDataCopy.variable = newData[0];
      this.publish(InternalEvent.Dashboard.DASHBOARD_VARIABLE_CHANGED, newData);
    } else {
      const variablesCopy = JSON.parse(JSON.stringify(metaDataCopy.variables));
      metaDataCopy.currentSelectionId = newData.id;
      variablesCopy.forEach((v, i) => {
        if (v.type === variableTypes.EXPRESSION) {
          v.expression = newData.variables[i].expression;
        } else {
          v.value = newData.variables[i].value;
        }
      });
      this.publish(InternalEvent.Dashboard.DASHBOARD_VARIABLE_CHANGED, variablesCopy);
    }

    WidgetService.updateWidgetMetaData(this.props.widget.id, metaDataCopy);
    this.publish(InternalEvent.Dashboard.CONTROL_UPDATED, {
      widgetId: this.props.widget.id,
      metaData: metaDataCopy
    });
  }

  handleSelectionChange(selected) {
    this.publishControlVariableChangeEvent("selection", selected);
    this.setState({
      selected
    });
  }

  handleInputControlValueChange(changes) {
    const state = JSON.parse(JSON.stringify(this.state));
    const variableCopy = Object.assign({}, this.props.widget.metaData.variable);
    for (let props in changes) {
      variableCopy[props] = changes[props];
      state[props] = changes[props];
    }
    if (this.timer) clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.publishControlVariableChangeEvent("input", [variableCopy]);
    }, updateDelay);
    this.setState(state);
  }

  /** Changes widget's z-index to prevent overlapping problem with the other widgets. **/
  handleOptionOrPickerOpen() {
    $(this.refs.container).parents("li").css("z-index", 100);
  }

  /** Sets the original z-index value. **/
  handleOptionOrPickerClose() {
    $(this.refs.container).parents("li").css("z-index", "");
  }

  getControlWidget() {
    const metaData = this.props.widget.metaData;
    switch (metaData.type) {
      case "input": {
        return <InputControl value={this.state.value} metaData={metaData}
                             showLabel={this.state.showLabel}
                             timezone={this.state.timezone}
                             onPickerOpen={this.handleOptionOrPickerOpen}
                             onPickerClose={this.handleOptionOrPickerClose}/>;
      }
      case "selection": {
        return <SelectionControl selected={this.state.selected}
                                 showLabel={this.state.showLabel}
                                 handleOpened={this.handleOptionOrPickerOpen}
                                 handleClosed={this.handleOptionOrPickerClose}
                                 onChange={this.handleSelectionChange} metaData={metaData}/>;
      }
      case "dataset": {
        return <DatasetControl value={this.state.value}
                               showLabel={this.state.showLabel}
                               metaData={metaData}
                               widgetId={this.props.widget.id}/>;
      }
    }
  }

  render() {
    const marginTop = this.state.scale < 0.8 ? "-10px" : 0;
    const style = !this.state.showLabel ? {marginTop, transform: `scale(${this.state.scale})`} : {};
    return (
      <div className={styles.widgetContainer} ref="container" style={style}>
        <div className="row" style={{marginBottom: 0}}>
          {this.getControlWidget()}
        </div>
      </div>
    );
  }
}

ControlWidget.propTypes = {
  widget: React.PropTypes.instanceOf(Widget).isRequired
};


// WEBPACK FOOTER //
// ./src/components/dashboard/control-widget/control-widget.jsx